import { TOGGLE_MODAL } from '../constants/modals';

export function toggleModal(name, visible) {
  return {
    type: TOGGLE_MODAL,
    payload: { name, visible },
  };
}
